module.exports = __webpack_public_path__ + "static/media/feat-chapter-img3.40e7f2a3.jpg";